import React, { useEffect, useState,Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import {formato_monto} from '../../../../common/Formatos'
import GrillaPerdidaParcial from './GrillaPerdidaParcial'
import GrillaPerdidaTotal from './GrillaPerdidaParcial'
const LiquidacionParcial= () => {
    const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
    const { cfg_form, liquidacionPerdida,antecedentesCasos } = data_datos_generales
    // liquidacionPerdida.liquidacionPerdida puede venir null (respuesta code:-1
    // "Sin Antecedentes de Liquidación") — la guarda de abajo se usa en vez de
    // "liquidacionPerdida.length !== 'undefined'", que compara contra el string
    // 'undefined' y por eso nunca protegía nada (siempre daba true).
    const datosLiquidacion = liquidacionPerdida && liquidacionPerdida.liquidacionPerdida


    return (
    <div>
      <Row>
      <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-mdapago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion['glosaMonedaPago']
              : null}
          </Form.Text>
        </Col>

        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-mtopago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? formato_monto(datosLiquidacion['mtoPago'])
              : null}
          </Form.Text>
        </Col>
       
        <Col>
          <Form.Label
            className=' mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-fechultpago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {antecedentesCasos && antecedentesCasos.length !== 'undefined'
              ? antecedentesCasos.antecedentesCasos[0]['UltFechaPagoFormat'] 
              : null}
          </Form.Text>
        </Col>
        

        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-sitpago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion['situacionPago']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-cntPagos']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion[
                  'cntFacturas'
                ]
              : null}
          </Form.Text>
        </Col>
      </Row>
      <Row>
      <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-mdaindem']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3'>
            {datosLiquidacion
              ? datosLiquidacion['glosaMonedaIndeminza']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-mtoindem']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? formato_monto(datosLiquidacion['mtoIndemnizacion'])
              : null}
          </Form.Text>
        </Col>
        
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-informeliq']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? (datosLiquidacion['indInformeLiquida']===1?"Si":"NO")
              : null}
          </Form.Text>
        </Col>
        
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-fechpago']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion['fechaPagoFormat']
              : null}
          </Form.Text>
        </Col>
        
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-facturas']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion['indicaFacturaVenta']
              : null}
          </Form.Text>
        </Col>
        
      </Row>
      <Row>
      <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-mdaprovi']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion['glosaMonedaPago']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-mtoprovi']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? formato_monto(datosLiquidacion['mtoProvision'])
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-mdasalva']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? datosLiquidacion['glosaMonedaSalvataje']
              : null}
          </Form.Text>
        </Col>
        <Col>
          <Form.Label
            className='mt-3 mb-0'
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            {cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-mtosalva']}
          </Form.Label>
          <br />
          <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
            {datosLiquidacion
              ? formato_monto(datosLiquidacion['mtoSalvataje'])
              : null}
          </Form.Text>
        </Col>
        <Col></Col>
      </Row>
      
    </div>
  )
}

export default LiquidacionParcial